import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "grid grid-cols-[auto_1fr] min-h-full bg-(--color-block-bg,#ffffff)" };
const _hoisted_2 = { class: "min-w-0 px-5 pt-6 pb-4 bg-white" };
const _hoisted_3 = { class: "max-w-270 mx-auto" };
const _hoisted_4 = { class: "flex items-center justify-between mb-6 sm:mb-8" };
const _hoisted_5 = { class: "text-2xl sm:text-3xl font-bold text-gray-900 shrink-0 mr-60" };
const _hoisted_6 = {
    key: 0,
    class: "text-sm text-gray-500 mt-1"
};
const _hoisted_7 = {
    key: 0,
    class: "flex flex-col items-center justify-center py-24",
    "data-testid": "matrix-loading"
};
const _hoisted_8 = { class: "text-sm text-gray-500" };
const _hoisted_9 = {
    key: 1,
    class: "flex flex-col items-center justify-center py-24",
    "data-testid": "matrix-load-error"
};
const _hoisted_10 = { class: "text-sm text-gray-700 mb-4" };
import { Button, FormSaveButton, UnsavedChangesModal } from "@eudonet/opal";
import { computed, onMounted, ref, shallowRef } from "vue";
import { useI18n } from "vue-i18n";
import { onBeforeRouteLeave } from "vue-router";
import { moduleRegistry } from "@/router/moduleRegistry";
import { useConsentMatrix } from "../../composables/useConsentMatrix";
import { resolveConsentPurposeLabel } from "../../composables/useConsentPurposeLabel";
import ConfirmMatrixChangesModal from "../components/ConfirmMatrixChangesModal.vue";
import ConsentMatrixGrid from "../components/ConsentMatrixGrid.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConsentMatrixConfigView',
    setup(__props) {
        const SidebarComponent = shallowRef(moduleRegistry.getComponentForSlot("sidebar"));
        const { locale } = useI18n();
        const { matrix, channels, purposes, purposeCatalogue, isLoading, isSaving, loadError, isDirty, diff, load, toggle, save, revert } = useConsentMatrix();
        const purposeLabels = computed(() => {
            const out = {};
            for (const p of purposeCatalogue.value) {
                // Omit purposes with no translation so consumers fall back to the static
                // consent.matrix.purpose.* Tolgee key for the built-in defaults.
                if (p.translations.length === 0) {
                    continue;
                }
                out[p.code.toLowerCase()] = resolveConsentPurposeLabel(p, locale.value);
            }
            return out;
        });
        const showConfirm = ref(false);
        const showUnsaved = ref(false);
        const pendingLeave = ref(null);
        const formattedUpdatedAt = computed(() => {
            if (!matrix.updatedAt) {
                return "";
            }
            return new Intl.DateTimeFormat(locale.value, {
                dateStyle: "medium",
                timeStyle: "short",
            }).format(new Date(matrix.updatedAt));
        });
        function openConfirm() {
            if (diff.value.length === 0) {
                return;
            }
            showConfirm.value = true;
        }
        async function handleConfirm() {
            await save();
            showConfirm.value = false;
        }
        onBeforeRouteLeave((_to, _from, next) => {
            if (!isDirty.value) {
                next();
                return;
            }
            pendingLeave.value = () => next();
            showUnsaved.value = true;
        });
        function onStay() {
            showUnsaved.value = false;
            pendingLeave.value = null;
        }
        function onLeave() {
            showUnsaved.value = false;
            revert();
            pendingLeave.value?.();
            pendingLeave.value = null;
        }
        onMounted(() => {
            void load();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (SidebarComponent.value)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(SidebarComponent.value), { key: 0 }))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("main", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("consent.matrix.title")), 1 /* TEXT */),
                                (!_unref(isLoading) && !_unref(loadError) && _unref(matrix).updatedAt)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("consent.matrix.lastUpdated", { date: formattedUpdatedAt.value })), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            (!_unref(isLoading) && !_unref(loadError))
                                ? (_openBlock(), _createBlock(_unref(FormSaveButton), {
                                    key: 0,
                                    enabled: _unref(isDirty),
                                    saving: _unref(isSaving),
                                    "save-label": _ctx.$t('form.saveChanges'),
                                    "saving-label": _ctx.$t('form.saving'),
                                    "disabled-hint": _ctx.$t('form.saveDisabledHint'),
                                    onSave: openConfirm
                                }, null, 8 /* PROPS */, ["enabled", "saving", "save-label", "saving-label", "disabled-hint"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        (_unref(isLoading))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-loader-4-line animate-spin text-4xl text-gray-400 mb-4" }, null, -1 /* CACHED */)),
                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("consent.matrix.loading")), 1 /* TEXT */)
                            ]))
                            : (_unref(loadError))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-error-warning-line text-4xl text-red-400 mb-4" }, null, -1 /* CACHED */)),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("consent.matrix.loadError")), 1 /* TEXT */),
                                    _createVNode(_unref(Button), {
                                        variant: "secondary",
                                        label: _ctx.$t('consent.matrix.retry'),
                                        onClick: _unref(load)
                                    }, null, 8 /* PROPS */, ["label", "onClick"])
                                ]))
                                : (_openBlock(), _createBlock(ConsentMatrixGrid, {
                                    key: 2,
                                    entries: _unref(matrix).entries,
                                    channels: _unref(channels),
                                    purposes: _unref(purposes),
                                    "purpose-labels": purposeLabels.value,
                                    onToggle: _unref(toggle)
                                }, null, 8 /* PROPS */, ["entries", "channels", "purposes", "purpose-labels", "onToggle"])),
                        _createVNode(ConfirmMatrixChangesModal, {
                            modelValue: showConfirm.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((showConfirm).value = $event)),
                            diff: _unref(diff),
                            saving: _unref(isSaving),
                            "purpose-labels": purposeLabels.value,
                            onConfirm: handleConfirm,
                            onCancel: _cache[1] || (_cache[1] = ($event) => (showConfirm.value = false))
                        }, null, 8 /* PROPS */, ["modelValue", "diff", "saving", "purpose-labels"]),
                        _createVNode(_unref(UnsavedChangesModal), {
                            modelValue: showUnsaved.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showUnsaved).value = $event)),
                            title: _ctx.$t('unsavedChanges.title'),
                            message: _ctx.$t('unsavedChanges.message'),
                            "stay-label": _ctx.$t('unsavedChanges.stay'),
                            "leave-label": _ctx.$t('unsavedChanges.leave'),
                            onStay: onStay,
                            onLeave: onLeave
                        }, null, 8 /* PROPS */, ["modelValue", "title", "message", "stay-label", "leave-label"])
                    ])
                ])
            ]));
        };
    }
});
